/* eslint-disable no-undef */
import React from 'react';
import PropTypes from 'prop-types';

import { StarRateIcon } from '../../../SharedComponents/Icons';

const MarkerDetailsContent = props => (
  <div>
    <a className="marker-info__title" title={I18n.t('list_view.map.info_window.read_more_title')} href={props.link}>
      {props.title}
    </a>
    <div className="markerblock-wrapper">
      <div className="marker-image">
        <a title={props.area} href={props.link}>
          <img src={props.imageUrl} alt="nearest marker location" />
        </a>
      </div>
      <div className="marker-info">
        <p>
          {I18n.t('list_view.map.info_window.office_size')}
          {props.area}
        </p>
        <div className="marker-rating">
          <p>
            {I18n.t('list_view.map.info_window.standard')}
          </p>
          {[...Array(props.stars_rating)].map(elem => (
            <StarRateIcon key={elem} />
          ))}
        </div>
      </div>
    </div>
  </div>
);

MarkerDetailsContent.propTypes = {
  imageUrl: PropTypes.string,
  area: PropTypes.string,
  link: PropTypes.string,
  title: PropTypes.string,
  stars_rating: PropTypes.number,
};

MarkerDetailsContent.defaultProps = {
  imageUrl: '',
  area: '',
  link: '',
  title: '',
  stars_rating: 4,
};


export default MarkerDetailsContent;
